/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface AppointmentLocationResponse
 */
export interface AppointmentLocationResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof AppointmentLocationResponse
     */
    locationId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof AppointmentLocationResponse
     */
    name: string;
}

/**
 * Check if a given object implements the AppointmentLocationResponse interface.
 */
export function instanceOfAppointmentLocationResponse(value: object): value is AppointmentLocationResponse {
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AppointmentLocationResponseFromJSON(json: any): AppointmentLocationResponse {
    return AppointmentLocationResponseFromJSONTyped(json, false);
}

export function AppointmentLocationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentLocationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'locationId': ApiUserTasksGetPageParameterFromJSON(json['locationId']),
        'name': json['name'],
    };
}

export function AppointmentLocationResponseToJSON(json: any): AppointmentLocationResponse {
    return AppointmentLocationResponseToJSONTyped(json, false);
}

export function AppointmentLocationResponseToJSONTyped(value?: AppointmentLocationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationId': ApiUserTasksGetPageParameterToJSON(value['locationId']),
        'name': value['name'],
    };
}

